export default __webpack_public_path__ + "static/media/information--exit-ahead--g3.36f7fe6b.png";